import ReactEcharts from "echarts-for-react";
import React, { FC } from "react";

interface DataInterface {
  property: string;
  value: number;
}
interface PieChartChartInterface {
  data: Array<DataInterface>;
  children?: React.ReactNode;
  titleValue?: string;
  title?: string;
  subTitle?: string;
  className?: string;
  download?: boolean;
  legendPosition?:
    | "top"
    | "left"
    | "right"
    | "bottom"
    | "inside"
    | "insideRight"
    | "insideLeft"
    | "insideTop"
    | "insideBottom";
}

export const PieChart: FC<PieChartChartInterface> = ({
  data,
  children,
  titleValue,
  className,
  title,
  subTitle,
  download,
  legendPosition,
}) => {
  const formatedData = data?.map((item: DataInterface) => ({
    ...item,
    name: item?.property,
  }));
  const option = {
    title: {
      text: title,
      subtext: subTitle,
      left: "center",
    },
    tooltip: {
      trigger: "item",
    },
    ...(download && {
      toolbox: {
        feature: {
          saveAsImage: {},
        },
      },
    }),
    // legend: {
    //   orient: "vertical",
    //   left: "left",
    //   top: legendPosition ?? "top",
    // },
    grid: {
      left: "3%",
      right: "4%",
      bottom: "3%",
      containLabel: true,
    },
    series: [
      {
        ...(titleValue && { name: titleValue }),
        type: "pie",
        radius: "50%",
        data: formatedData,
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
      },
    ],
  };
  return (
    <div>
      <div className="mx-[40px]">{children}</div>
      <ReactEcharts option={option} className={`${className} w-full `} />
    </div>
  );
};
